// export const formatCurrencyAUD = (amount) => {
//     if (amount == null || isNaN(amount)) return "$0.00";
//     return new Intl.NumberFormat("en-AU", {
//         style: "currency",
//         currency: "AUD",
//     }).format(amount);
// };

export const formatCurrencyAUD = (amount) => {
  if (amount == null || isNaN(amount)) return "0.00";
  return new Intl.NumberFormat("en-AU", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(amount);
};

export const formatNumberWithCommas = (value) => {
  if (value === "" || value == null) return "";
  const numberValue = value.toString().replace(/,/g, "");
  if (isNaN(Number(numberValue))) return value; // <-- FIX
  const [intPart, decimalPart] = numberValue.split(".");
  const formattedInt = new Intl.NumberFormat("en-AU").format(intPart);
  return decimalPart !== undefined
    ? `${formattedInt}.${decimalPart}`
    : formattedInt;
};
